import { MutationTree } from 'vuex'
import { FilterState } from './filters.types'

export enum MutationTypes {
  SET_ALL_FILTERS_LOADING_ERROR = 'SET_ALL_FILTERS_LOADING_ERROR',
  SET_ALL_FILTERS_LOADING = 'SET_ALL_FILTERS_LOADING',
  SET_ALL_FILTERS_LOADED = 'SET_ALL_FILTERS_LOADED',
  SET_ALL_FILTERS_LOADING_SUCCESS = 'SET_ALL_FILTERS_LOADING_SUCCESS'
}

export const mutations: MutationTree<FilterState> = {
  [MutationTypes.SET_ALL_FILTERS_LOADING_ERROR](state, error) {
    state.allFilterLoadingError = error
  },
  [MutationTypes.SET_ALL_FILTERS_LOADING](state, bool) {
    state.allFilterLoading = bool
  },
  [MutationTypes.SET_ALL_FILTERS_LOADED](state, bool) {
    state.allFilterLoaded = bool
  },
  [MutationTypes.SET_ALL_FILTERS_LOADING_SUCCESS](state, bool) {
    state.allFilterLoadingSuccess = bool
  }
}
